import { render, staticRenderFns } from "./TerritoryArea.vue?vue&type=template&id=6b949290&scoped=true"
import script from "./TerritoryArea.vue?vue&type=script&lang=js"
export * from "./TerritoryArea.vue?vue&type=script&lang=js"
import style0 from "./TerritoryArea.vue?vue&type=style&index=0&id=6b949290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b949290",
  null
  
)

export default component.exports